import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row v-theme--light align-items-center" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "col-1 d-flex align-items-center" }

import { computed } from 'vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue';
import VehicleAutoComplete from '@/components/AutoCompletes/VehicleAutoComplete.vue';
import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
import i18n from '@/lang/i18n';
import type getOperationOffice from '@/types/responses/getOperationOffice';
import type getDepartmentResponse from '@/types/responses/getDepartment';


export default /*@__PURE__*/_defineComponent({
  __name: 'MileageCorrectionSearchForm',
  props: {
    selectedOperationOffice: {},
    selectedDepartment: {},
    selectedVehicle: {},
    dateRange: {},
    loading: { type: Boolean },
    maxDateRange: {}
  },
  emits: ["update:selectedOperationOffice", "update:selectedDepartment", "update:selectedVehicle", "update:dateRange", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedOperationOffice = computed({
  get: () => props.selectedOperationOffice,
  set: (val) => emit('update:selectedOperationOffice', val),
});

const selectedDepartment = computed({
  get: () => props.selectedDepartment,
  set: (val) => emit('update:selectedDepartment', val),
});

const selectedVehicle = computed({
  get: () => props.selectedVehicle,
  set: (val) => emit('update:selectedVehicle', val),
});

const dateRange = computed({
  get: () => props.dateRange,
  set: (val) => emit('update:dateRange', val),
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SingleOperationOfficeAutoComplete, {
        modelValue: selectedOperationOffice.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOperationOffice).value = $event)),
        clearable: true,
        selectFirstIfOnlyOne: ""
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DepartmentAutoComplete, {
        modelValue: selectedDepartment.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDepartment).value = $event)),
        operationOffices: selectedOperationOffice.value ? [selectedOperationOffice.value] : [],
        selectFirstIfOnlyOne: false
      }, null, 8, ["modelValue", "operationOffices"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(VehicleAutoComplete, {
        modelValue: selectedVehicle.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedVehicle).value = $event)),
        selectedDepartment: selectedDepartment.value ?? null,
        operationOffices: selectedOperationOffice.value ? [selectedOperationOffice.value] : [],
        requestParams: { type: 'filter' }
      }, null, 8, ["modelValue", "selectedDepartment", "operationOffices"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(RangeDatePicker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateRange).value = $event)),
        maxRange: props.maxDateRange,
        format: "yyyy/MM/dd",
        isError: false
      }, null, 8, ["modelValue", "maxRange"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_btn, {
        class: "exec-btn",
        loading: props.loading,
        disabled: !selectedVehicle.value || !selectedOperationOffice.value,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('search')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.exec')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ]))
}
}

})